import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appDateMask]',
  standalone: true
})
export class DateMaskDirective implements OnInit {
  // Masque initial par défaut
  private defaultTemplate = '00/00/0000';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    // Initialise le champ avec le masque si vide
    const input = this.el.nativeElement as HTMLInputElement;
    if (!input.value) {
      input.value = this.defaultTemplate;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    // Touches de navigation autorisées
    const navKeys = ['ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
    if (navKeys.includes(event.key)) {
      return;
    }

    // Gestion de l'effacement (Backspace / Retour arrière)
    if (event.key === 'Backspace') {
      event.preventDefault();
      this.replaceWithDefault(input, start === end ? start - 1 : start, end, true);
      return;
    }

    // Gestion de la suppression (Delete / Suppr)
    if (event.key === 'Delete') {
      event.preventDefault();
      this.replaceWithDefault(input, start, start === end ? start + 1 : end, false);
      return;
    }

    // Gestion de l'écriture d'un chiffre
    if (/^\d$/.test(event.key)) {
      event.preventDefault();
      this.writeDigit(input, event.key, start);
      return;
    }

    // Bloquer toutes les autres touches (lettres, caractères spéciaux)
    event.preventDefault();
  }

  private replaceWithDefault(input: HTMLInputElement, start: number, end: number, moveCursorBack: boolean): void {
    if (start < 0 || start >= 10) return;

    let currentVal = input.value.split('');

    // Si aucune sélection de bloc, on cible un seul caractère
    const actualEnd = start === end ? start + 1 : end;

    for (let i = start; i < actualEnd; i++) {
      if (i === 2 || i === 5) {
        currentVal[i] = '/'; // Préserve les séparateurs
      } else if (i < 10) {
        currentVal[i] = '-'; // Remplace par zéro
      }
    }

    input.value = currentVal.join('');

    // Repositionne le curseur logiquement après l'effacement
    const newCursorPos = moveCursorBack ? start : start + 1;
    input.setSelectionRange(newCursorPos, newCursorPos);
    input.dispatchEvent(new Event('input'));
  }

  private writeDigit(input: HTMLInputElement, digit: string, position: number): void {
    if (position >= 10) return;

    // Si le curseur est sur un '/', on écrit sur la position suivante
    let targetPos = position;
    if (targetPos === 2 || targetPos === 5) {
      targetPos++;
    }

    let currentVal = input.value.split('');
    currentVal[targetPos] = digit;
    input.value = currentVal.join('');

    // Avancer le curseur après le chiffre saisi
    let nextCursorPos = targetPos + 1;
    if (nextCursorPos === 2 || nextCursorPos === 5) {
      nextCursorPos++; // Saute le '/' automatiquement
    }

    input.setSelectionRange(nextCursorPos, nextCursorPos);
    input.dispatchEvent(new Event('input'));
  }
}
